<!-- views to render when the selected view is empty -->
<!-- currently only supports the following view -->
@switch (selectedViewId$ | async) {
  @case (followingViewId) {
    <div class="following-view-empty">
      <glxy-empty-state>
        <glxy-empty-state-hero>
          <div class="hero-image"></div>
        </glxy-empty-state-hero>
        <p>
          Tap the ★ on any conversation you want to follow,
          <span class="nowrap">and it will appear here.</span>
        </p>
      </glxy-empty-state>
    </div>
  }
}
